/* Business type — broad groups of Companies House SIC codes. The mapping
 * from codes to groups lives on the server (system/server/lib/businessType.js)
 * and arrives on each search row as company.types; this list is only the keys
 * and labels, in the same order. CHANGE ONE, CHANGE THE OTHER. */

export const TYPE_OPTIONS = [
    { key: "fashion", label: "Fashion, clothing & textiles" },
    { key: "jewellery", label: "Jewellery & watches" },
    { key: "beauty", label: "Beauty & cosmetics" },
    { key: "health", label: "Pharmacy, health & medical" },
    { key: "food", label: "Food & drink" },
    { key: "hospitality", label: "Hotels, restaurants & catering" },
    { key: "home", label: "Home, furniture & DIY" },
    { key: "electronics", label: "Electronics, computers & IT" },
    { key: "motor", label: "Motor vehicles & parts" },
    { key: "leisure", label: "Toys, sport & leisure" },
    { key: "media", label: "Printing, books & media" },
    { key: "online", label: "Online retail" },
    { key: "retail", label: "Other shops & retail" },
    { key: "wholesale", label: "General wholesale & trading" },
    { key: "chemicals", label: "Chemicals, plastics & rubber" },
    { key: "engineering", label: "Metals, machinery & engineering" },
    { key: "manufacturing", label: "Other manufacturing" },
    { key: "construction", label: "Construction & building supplies" },
    { key: "farming", label: "Farming, fishing & forestry" },
    { key: "energy", label: "Energy, utilities & recycling" },
    { key: "logistics", label: "Transport, freight & logistics" },
    { key: "professional", label: "Professional services & consultancy" },
    { key: "support", label: "Business support services" },
    { key: "finance", label: "Finance & property" },
    { key: "public", label: "Education, care & public sector" },
    { key: "other", label: "Other services" },
];
const OFFERED = new Set(TYPE_OPTIONS.map((o) => o.key));

export const typeLabel = (key) => TYPE_OPTIONS.find((o) => o.key === key)?.label || null;

// A stored/saved selection with anything we no longer offer removed.
export const offeredTypes = (types) => (types || []).filter((k) => OFFERED.has(k));

// Keep a trader in ANY chosen type. No Companies House match = no type = no match.
// Mirrored in system/server/lib/searchFilters.js.
export const matchesType = (trader, types) => {
    const chosen = offeredTypes(types);
    return !chosen.length || chosen.some((k) => (trader.company?.types || []).includes(k));
};
